let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9ZdQB")).then(() => parcelRequire('1KpW7'));